package org.moxultimate.topwithmox.product.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * ProductContentTypeResponse
 * Single row returned by GET /product-content-type.
 * The [type] string is used to populate type filter chips in the Products page.
 *
 * @param id Auto-generated database ID.
 * @param type Type label stored in the product_content_types table (e.g. "Gaming", "Peripherals").
 */
@Serializable
data class ProductContentTypeResponse(
    @SerialName("id") val id: Long,
    @SerialName("type") val type: String? = null,
)
